import { render } from "./TheButton.vue?vue&type=template&id=5d4d8f36&scoped=true"
import script from "./TheButton.vue?vue&type=script&lang=js"
export * from "./TheButton.vue?vue&type=script&lang=js"

import "./TheButton.vue?vue&type=style&index=0&id=5d4d8f36&scoped=true&lang=css"

import exportComponent from "/home/emrdev/Project/work/sibugol_dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d4d8f36"]])

export default __exports__